import { YesNo } from '@customer/store/apis/assetsApi';
import { setAudible } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import SingleSelectFilter from './SingleSelectFilter';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';

const useYesNoOptions = (): DropdownItemProps<YesNo>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.keys(YesNo).map((key: string) => {
      const value = YesNo[key as keyof typeof YesNo];
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`filters.YesNo.${key}`),
      };
    });
  }, [t]);
};

export const AudibleFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownElement>) => {
  const { t } = useTranslation();

  return (
    <SingleSelectFilter<YesNo>
      filterName="audible"
      label={label ?? t('Audible')}
      elementRef={elementRef}
      action={setAudible}
      useItemsHook={useYesNoOptions}
    />
  );
};

export default AudibleFilter;
